/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Inbound_Exception_Not_OpenInputs */

const en_error_inbound_exception_not_open = /** @type {(inputs: Error_Inbound_Exception_Not_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This inbound has no difference to confirm: it is not received, or its outcome is already confirmed.`)
};

/**
* | output |
* | --- |
* | "This inbound has no difference to confirm: it is not received, or its outcome is already confirmed." |
*
* @param {Error_Inbound_Exception_Not_OpenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_inbound_exception_not_open = /** @type {((inputs?: Error_Inbound_Exception_Not_OpenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Inbound_Exception_Not_OpenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_inbound_exception_not_open(inputs)
});